export const isBackgroundTransparent = bg => bg && bg === "transparent";

export default isBackgroundTransparent;
